import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {withRouter} from 'react-router-dom';
import {Icon} from 'front-onceforall-core';
import Skeleton from '@material-ui/lab/Skeleton';
import {ProjectDossierStatsContext} from '../../views/projectDetails/ProjectDetailsView';

export const ProjectParticipants = props => {
  const handleGoToChart = () => {
    props.history.push(`/project/${props.project.projectId}/intervention/${props.myIntervention.interventionId}/chart`);
  };

  const isProjectOwner = props.project.ownerOrganisation.organisationId === props.myIntervention.organisation.organisationId;
  const title = props.myIntervention.role === 'CLIENT' || isProjectOwner ? 'project.participants.title' : 'project.subcontractors.title';
  const description = props.myIntervention.role === 'CLIENT' || isProjectOwner ? 'project.participants.description' : 'project.subcontractors.description';

  return (
    <ProjectDossierStatsContext.Consumer>
      {value => (
        <div className="card">
          <div className="card-header">
            <div className="card-title"><Translate value={title}/></div>
          </div>
          <div
            className="flex-container column center space-between"
            style={{height: 'calc(100% - 48px)'}}
          >
            <div className="simple-number-stats mb-5 w-100">
              <div className="number flex-container column center information-primary">
                {value.participants.loading ?
                  <Skeleton
                    variant="rect"
                    height={62}
                    width={41}
                  /> :
                  value.participants.count
                }
              </div>
              <div className="label w-100">
                {value.participants.loading ?
                  <Skeleton variant="text"/> :
                  <Translate value={description}/>
                }
              </div>
            </div>
            <button
              type="button"
              className="large link inline-container"
              onClick={() => handleGoToChart()}
            >
              <Icon icon="organisation"/>
              <Translate value="project.goToChart"/>
            </button>
          </div>
        </div>
      )}
    </ProjectDossierStatsContext.Consumer>
  );
};

ProjectParticipants.propTypes = {
  history: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
  myIntervention: PropTypes.object.isRequired
};

export default withRouter(ProjectParticipants);
